import { performGqlFetch } from '@atlassian/conversation-assistant-service';

export const fetchAgg = async <T, U>({
	siteId,
	graphQuery,
	variables,
}: {
	siteId?: string;
	graphQuery: string;
	variables: U;
}) => {
	const response = await performGqlFetch<T, U>({
		gqlQuery: graphQuery,
		variables: {
			siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
			...variables,
		},
	});

	return response;
};
